module.exports = __webpack_public_path__ + "img/device_car.4be0a77e.svg";